import { featureList } from '@/mocks/movies';

export default function Features() {
  return (
    <section id="features" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-secondary-700 text-xs md:text-sm font-medium tracking-wide">
            <i className="ri-sparkling-2-line" />
            观影特色
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 text-balance">
            九七电影院围绕哪些方向做整理
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            与其在搜索结果里逐个猜测，不如先看清本站能提供的四个方向。下面这些说明对应你最常见的使用场景，
            每一块都指向具体能做什么，而不是空泛的口号。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featureList.map((item) => (
            <article
              key={item.title}
              className="group rounded-lg bg-background-50 border border-background-200/80 p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-2xl">
                <i className={item.icon} />
              </div>
              <h3 className="mt-4 font-heading font-semibold text-base md:text-lg text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2.5 text-foreground-600 text-xs md:text-sm leading-relaxed">
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}